export const propRules = {
  rules: {
    heading: "Regole dell'alloggio",
    subheading:
      "Imposta gli orari di check-in e check-out che verranno comunicati all'ospite durante il check-in.",
    cloneTitleNoun: "orari",
    cloneItemNoun: "gli orari",
    bulkNoticePrefix:
      "Questa modifica verrà applicata ai {count} alloggi collegati a",
    checkinLabel: "Check-in",
    checkoutLabel: "Check-out",
    defaultCheckin: "Predefinito 15:00",
    defaultCheckout: "Predefinito 12:00",
    saving: "Salvataggio…",
    save: "Salva",
    toasts: {
      loadError: "Impossibile caricare i dati dell'annuncio.",
      bulkApplied: "Regole applicate a {count} alloggi",
      saveSuccess: "Regole salvate con successo",
      bulkPartialError: "Non è stato possibile aggiornare alcuni alloggi",
      saveError: "Errore durante il salvataggio delle regole",
    },
  },
  services: {
    cloneTitleNoun: "dotazioni e comfort",
    cloneItemNoun: "le dotazioni e i comfort",
    toasts: {
      saveSuccess: "Servizi salvati con successo",
      saveError: "Errore durante il salvataggio dei servizi",
    },
  },
  maintenance: {
    title: "Manutenzione dell'alloggio",
    scopeProperty: "Intero alloggio",
    scopeUnits: "Unità specifiche",
    selectUnits: "Seleziona le unità",
    dateFrom: "Da",
    dateTo: "A",
    closeArrivals: "Blocca gli arrivi (CTA)",
    closeDepartures: "Blocca le partenze (CTD)",
    applying: "Applicazione in corso...",
    apply: "Applica manutenzione",
    removing: "Rimozione in corso...",
    remove: "Rimuovi manutenzione",
    toasts: {
      rangeScopeRequired:
        "Completa l'intervallo di date e l'ambito (unità o alloggio).",
      applied: "Manutenzione applicata.",
      applyError: "Errore durante l'applicazione della manutenzione.",
      removed: "Manutenzione rimossa.",
      removeError: "Errore durante la rimozione della manutenzione.",
    },
  },
  propMaintenance: {
    title: "Manutenzione dell'alloggio",
    scopeProperty: "Intero alloggio",
    scopeUnits: "Unità specifiche",
    selectUnits: "Seleziona le unità",
    dateFrom: "Da",
    dateTo: "A",
    closeArrivals: "Blocca gli arrivi (CTA)",
    closeDepartures: "Blocca le partenze (CTD)",
    applying: "Applicazione in corso...",
    apply: "Applica manutenzione",
    removing: "Rimozione in corso...",
    remove: "Rimuovi manutenzione",
    toasts: {
      rangeScopeRequired:
        "Completa l'intervallo di date e l'ambito (unità o alloggio).",
      applied: "Manutenzione applicata.",
      applyError: "Errore durante l'applicazione della manutenzione.",
      removed: "Manutenzione rimossa.",
      removeError: "Errore durante la rimozione della manutenzione.",
    },
  },
};
